<template>
  <div>
    <div class="book">
      <!-- get first page -->
      <div id="pageId" class="page">
        <div
          v-if="assetDataFirst.length > 0"
          id="productTitle"
          class="text-center"
        >
          {{
            `${itemPerRow} x ${numberQRRow + 1}`
          }}
        </div>
        <div
          id="productQRCodeRow"
          ref="productQRCodeRow"
          style="padding: 0; margin: 0; display: flex"
        >
          <div
            v-for="(item, index) in assetDataFirst"
            :key="item + index"
            style="padding: 4px; margin: 0px; width: fit-content"
          >
            <!--  -->
            <qrcode-vue
              :value="item.assetCode"
              :size="qrCodeSize"
              level="H"
              render-as="svg"
              style="text-align: center; padding: 5px; border: 1px solid #000"
            />
            <div v-show="isShowAssetCode" style="padding: 0 5px;" :style="`width: ${qrCodeSize + 12}px`">
              <div class="qr-code-asset-code">
                <span>{{ item.assetCode }}</span>
              </div>
            </div>
            <div v-show="isShowAssetName" class="qr-code-asset-name" :style="`width: ${qrCodeSize + 12}px`">
              <span>{{ item.assetName }}</span>
            </div>
          </div>
        </div>
        <div
          v-for="(row, index) in assetDataList"
          :key="row + index"
          class="d-flex"
          style=" display: flex"
        >
          <div
            v-for="(item, index) in row"
            :key="item + index"
            style="padding: 4px;"
          >
            <qrcode-vue
              :value="item.assetCode"
              :size="qrCodeSize"
              level="H"
              render-as="svg"
              style="text-align: center; padding: 5px; border: 1px solid #000"
            />
            <div v-show="isShowAssetCode" style="padding: 0 5px;" :style="`width: ${qrCodeSize + 12}px`">
              <div class="qr-code-asset-code">
                <span>{{ item.assetCode }}</span>
              </div>
            </div>
            <div v-show="isShowAssetName" class="qr-code-asset-name" :style="`width: ${qrCodeSize + 12}px`">
              <span>{{ item.assetName }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- for asset in list -->
      <div v-for="(pageItem, index) in afterNumberPagePrint" :key="pageItem + index">
        <div class="page">
          <div class="text-center">
            ({{
              `${itemPerRow} x ${pageItem.length}`
            }})
          </div>
          <div
            v-for="(row, index) in pageItem"
            :key="row + index"
            class="d-flex"
            style=" display: flex"
          >
            <div
              v-for="(item, index) in row"
              :key="item + index"
              style="padding: 4px;"
            >
              <qrcode-vue
                :value="item.assetCode"
                :size="qrCodeSize"
                level="H"
                render-as="svg"
                style="text-align: center; padding: 5px; border: 1px solid #000"
              />
              <div v-show="isShowAssetCode" style="padding: 0 5px;">
                <div class="qr-code-asset-code">
                  <span>{{ item.assetCode }}</span>
                </div>
              </div>
              <div v-show="isShowAssetName" class="qr-code-asset-name">
                <span>{{ item.assetName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-print" style="position: fixed; bottom: 5px; right: 5px">
      <button
        type="button"
        class="btn btn-primary pull-right"
        @click="onPrintPage"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-print"></i>
        </span>
        {{ $t("common.print") }}
      </button>
    </div>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import QrcodeVue from "qrcode.vue";
import utils from "@/lib/utils";
import siteImgConfig from '@/lib/siteImgConfig'
import buildConfig from "../../../build/config"

export default {
  components: {
    QrcodeVue,
    loading: Loading
  },
  data: () => ({
    isLoading: false,
    numberItemInRowArray: [],
    numberQRRow: 0,
    assetDataFirst: [],
    assetDataList: [],
    afterNumberPagePrint: [],
    // numberQRRowList: [],
    //
    isShowAssetCode: null,
    isShowAssetName: null,
    itemPerRow: null,
    qrCodeSize: 0,
    pageHeight: 0,
    productTitle: 0,
    //
    search: {
      assetCodeAndName: "",
      location: "",
      maintenancePersonnel: "",
      status: "",
      maintainance_start_date: "",
      nextMaintainanceDate: "",
      assetType: ""
    },
    siteImgConfig: siteImgConfig
  }),
  watch: {
    GET_ASSET_LIST_V2_NO_PAGE_DATA: function() {
      this.assetDataList = [];
      let data = this.GET_ASSET_LIST_V2_NO_PAGE_DATA;
      this.assetDataFirst = []
      let itemPerRowIndex = this.itemPerRow > 0 ? this.itemPerRow - 1 : this.itemPerRow
      let countFirstPage = 0
      // 
      this.afterNumberPagePrint = []
      let countNumberRowAfterPage = 0
      let numberRowInAfterPage = this.numberQRRow + 1
      let numberAfterPage = 0

      data.forEach((e, index) => {
        let item = {
          id: e.id,
          assetCode: e.code,
          assetName: e.name
        };
        // get data first page
        if (index <= itemPerRowIndex) {
          this.assetDataFirst.push(item);
        } else {
          // get array list in fisrt page
          this.assetDataList[countFirstPage] =
           Array.isArray(this.assetDataList[countFirstPage])
           ? this.assetDataList[countFirstPage] : []
          if (this.assetDataList.length < this.numberQRRow) {
            if (this.assetDataList[countFirstPage].length < this.itemPerRow) {
              this.assetDataList[countFirstPage].push(item)
            } else {
              countFirstPage += 1
              this.assetDataList[countFirstPage] = []
              this.assetDataList[countFirstPage].push(item)
            }
          } else if (this.assetDataList.length === this.numberQRRow 
            && this.assetDataList[countFirstPage].length < this.itemPerRow) {
            this.assetDataList[countFirstPage].push(item)
          }
          // get data after first page
          else {
            if (Array.isArray(this.afterNumberPagePrint[numberAfterPage])) {
              let pageArray = this.afterNumberPagePrint[numberAfterPage]
              if (pageArray.length < numberRowInAfterPage) {
                if (Array.isArray(pageArray[countNumberRowAfterPage])) {
                  if (pageArray[countNumberRowAfterPage].length < this.itemPerRow) {
                    pageArray[countNumberRowAfterPage].push(item)
                  } else {
                    countNumberRowAfterPage += 1
                    pageArray[countNumberRowAfterPage] = []
                    pageArray[countNumberRowAfterPage].push(item)
                  }
                } else {
                  pageArray[countNumberRowAfterPage] = []
                  pageArray[countNumberRowAfterPage].push(item)
                }
              } else if(pageArray.length === numberRowInAfterPage
                && pageArray[countNumberRowAfterPage] !== undefined
                && pageArray[countNumberRowAfterPage].length < this.itemPerRow) {
                  pageArray[countNumberRowAfterPage].push(item)
              } else {
                numberAfterPage += 1
                countNumberRowAfterPage = 0
                this.afterNumberPagePrint[numberAfterPage] = []
                this.afterNumberPagePrint[numberAfterPage][countNumberRowAfterPage] = []
                this.afterNumberPagePrint[numberAfterPage][countNumberRowAfterPage].push(item)
              }
            } else {
              this.afterNumberPagePrint[numberAfterPage] = []
              this.afterNumberPagePrint[numberAfterPage][countNumberRowAfterPage] = []
              this.afterNumberPagePrint[numberAfterPage][countNumberRowAfterPage].push(item)
            }
          }
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ASSET_LIST_V2_NO_PAGE_DATA"
    ])
  },
  methods: {
    getAssetList: function() {
      let filter = {
        params: {
          assetCodeAndName: utils.getCleanStringValue(this.search.assetCodeAndName),
          location: utils.getCleanStringValue(this.search.location),
          maintenancePersonnel: utils.getCleanStringValue(this.search.maintenancePersonnel),
          status: utils.getCleanStringValue(this.search.status),
          lastMaintainanceDate: utils.getCleanStringValue(this.search.maintainance_start_date),
          nextMaintainanceDate: utils.getCleanStringValue(this.search.nextMaintainanceDate),
          assetType: utils.getCleanStringValue(this.search.assetType)
        }
      };
      this.isLoading = true;
      this.GET_ASSET_LIST_V2(filter)
        .then(
          async function(res) {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPrintPage: function() {
      window.print();
    },
    createArray: function(value) {
      let array = Array.from(Array(parseInt(value)).keys());
      return array;
    },
    getNumberRow: function() {
      let value =
        this.pageHeight - (parseInt(this.qrCodeSize) + 20) - this.productTitle;
      let numberRow = parseInt(value / (this.qrCodeSize + 20 + 5));
      return numberRow > 1 ? numberRow - 1 : numberRow;
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===buildConfig.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo()
      link.href = siteInfo.urlIcon
      document.title = siteInfo.site_name_info
    },
    ...mapActions([
      "ERROR_TOAST",
      // "GET_ASSET_TYPE_LIST",
      "GET_ASSET_LIST_V2"
    ])
  },
  async mounted() {
    var elmnt = await document.getElementById("productQRCodeRow");
    var productTitle = await document.getElementById("productTitle");
    var pageHeight = await document.getElementById("pageId");
    this.pageHeight = pageHeight ? pageHeight.clientHeight : 10;
    this.productTitle = productTitle ? productTitle.clientHeight : 10;
    this.qrCodeSize = elmnt.clientWidth / this.itemPerRow - 20;
    this.numberQRRow = this.getNumberRow();
    // this.numberQRRowList = this.createArray(this.getNumberRow() + 1);
  },
  created() {
    this.updateTabTitle()
    let queryData = this.$route.query;
    // is show info
    this.isShowAssetCode = JSON.parse(queryData.isShowAssetCode);
    this.isShowAssetName = JSON.parse(queryData.isShowAssetName);
    this.itemPerRow = parseInt(queryData.itemPerRow);
    // search data
    this.search.assetCodeAndName =
      queryData.assetCodeAndName !== undefined
        ? queryData.assetCodeAndName
        : null;
    this.search.location =
      queryData.location !== undefined ? queryData.location : null;
    this.search.maintenancePersonnel =
      queryData.maintenancePersonnel !== undefined
        ? queryData.maintenancePersonnel
        : null;
    this.search.status =
      queryData.status !== undefined ? queryData.status : null;
    this.search.lastMaintainanceDate =
      queryData.lastMaintainanceDate !== undefined
        ? queryData.lastMaintainanceDate
        : null;
    this.search.nextMaintainanceDate =
      queryData.nextMaintainanceDate !== undefined
        ? queryData.nextMaintainanceDate
        : null;
    this.search.assetType =
      queryData.assetType !== undefined ? queryData.assetType : null;
    this.getAssetList();
    this.numberItemInRowArray = this.createArray(this.itemPerRow);
  }
};
</script>
<style lang="scss" scoped>
body.print {
  overflow: initial;
}
body.print {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt;
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  width: 210mm;
  height: 297mm;
  padding: 2mm;
  margin: 10mm auto;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.subpage {
  height: 257mm;
}

@page {
  size: A4;
  margin: 0;
}
@media print {
  html {
    width: 100%;
    height: 297mm;
  }
  body.print {
    width: 100%;
    height: 297mm;
  }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
}
.theme--dark.v-sheet {
  padding: 5px;
}

.qr-code-asset-code {
  padding: 1px 5px;
  border-radius: 25px;
  background: #dddddd;
  text-align: center;
  margin-top: 5px;
}
.qr-code-asset-name {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/PrintQRCodeAsset.vue